import "./OEMEquipmentManufacturers.module.css";
import Header from "@/reusable_sections/Header";
import Pageheader from "./sections/Pageheader";
import Directanswerblock from "./sections/Directanswerblock";
import Whyoemmanufacturersuseevermark from "./sections/Whyoemmanufacturersuseevermark";
import Whatevermarksuppliesoems from "./sections/Whatevermarksuppliesoems";
import Howoemprogramworks from "./sections/Howoemprogramworks";
import Consistencytraceabilitystandards from "./sections/Consistencytraceabilitystandards";
import Howtosetupprogram from "./sections/Howtosetupprogram";
import Oemmarkingfaq from "./sections/Oemmarkingfaq";
import Closingcta from "./sections/Closingcta";
import Footer from "@/reusable_sections/Footer";
export default function OEMEquipmentManufacturersPage() {
  return <div>
      <Header />
      <Pageheader />
      <Directanswerblock />
      <Whyoemmanufacturersuseevermark />
      <Whatevermarksuppliesoems />
      <Howoemprogramworks />
      <Consistencytraceabilitystandards />
      <Howtosetupprogram />
      <Oemmarkingfaq />
      <Closingcta />
      <Footer />
    </div>;
}